<div header="Remove Project" class="align-items-center">
    <h5 class="block mb-3">Remove {{ codeName() }}?</h5>
    <p class="m-0 mb-5 text-sm text-black-alpha">It will no longer be visible to any member of your firm. Staffing, timekeeping and payroll records are kept. Contact support to restore it.</p>

    <div class="flex justify-content-end gap-2">
        <p-button label="Cancel" size="large"
            [rounded]="true"
            [outlined]="true" (click)="closeDialog()" />
        <p-button label="Remove" [rounded]="true" size="large" severity="danger" (click)="remove()" />
    </div>
</div>
